
export const PortalSharedResourceTypes = [
    'DocumentArchiveFile',
    //'SurveyReport'
] as const;

export type PortalSharedResourceType = typeof PortalSharedResourceTypes[number];

// ----------- Update types --------------------------------------------------

export type DocumentArchivePortalSharedResourceConfig = {
    note:string
};


type PortalSharedResourceBase = {
    resourceId: string,
    sharedAt: Date,
    sharedByUserId: string
}

export type PortalSharedDocument = PortalSharedResourceBase & {
    resourceType: 'DocumentArchiveFile',
    config: DocumentArchivePortalSharedResourceConfig
}

export type PortalSharedResource = PortalSharedDocument; // For now we only have one resource type, but this allows us to easily add more in the future without changing the existing type definition


// ----------- Read types --------------------------------------------------

type PortalSharedResourceViewBase = {
    resourceId: string
}

export type PortalSharedDocumentView = PortalSharedResourceViewBase & {
    resourceType: 'DocumentArchiveFile',
    // path:string[], No need for now
    publicFileName:string,
    privateFileName:string,
    sizeBytes:number,
    created: Date,
    note: string
}

export type PortalSharedResourceView = 
    PortalSharedDocumentView; // For now we only have one resource type, but this allows us to easily add more in the future without changing the existing type definition